import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLongArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.00016 1.3335V10.6668M6.00016 10.6668L10.6668 6.00016M6.00016 10.6668L1.3335 6.00016",
		stroke: "currentcolor",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLongArrowDown;
